'use strict';

import ordinal from 'ordinal';

export default (position, {tie, justNumber = false, status}) => {
  let display = '';

  if (position) {
    if (justNumber) {
      display = (tie ? 'T' : '') + position;
    } else {
      display = (tie ? 'T' : '') + ordinal(position);
    }
  } else {
    display = status;
  }

  return display;
};
